<template>
  <div id="content-wrapper">
    <div class="container">
      <div class="row">
        <div class="col-sm-12">
          <div class="row">
            <div class="col-sm-5">
              <div class="frame-overlay">
              <img src="/images/nftframel.png" class="empty-frame" />
                <!-- <span v-if="totalSupply < 15976" class="frame-text"
                  >#{{ totalSupply }} / 15976</span
                > -->
              <p v-if="totalSupply < 15976" style="text-align: center">
                  <!-- {{ remainingAtCurrentPrice }} left at this price  -->
                </p>
                <p v-else style="text-align: center">The sale has ended</p>
              </div>
            </div>
            <div class="col-sm-7">
              <div class="page-title" style="padding: 20px; padding-top: 45px">
                <h1>{{$t('menu.title')}}<br /></h1>
                <h5> {{$t('home.mxt')}}</h5>
                <p class="sale-section">
                {{$t('home.mx')}}
                 <br /><br />
                 {{$t('home.mx1')}}<a
                href="https://www.yuque.com/books/share/9888bb5e-a9a1-4f30-902d-047897d7d915"
                target="_blank" 
                > {{$t('home.qb')}}</a
              >
                 <br /><br />
                  <!-- <button class="mint-button"  disabled="disabled" >
                    <div>
                    {{$t('home.number')}}:
                     <input
                    type="number"
                    min="1"
                    max="20" value="2" ref="getValue" />              
                    </div>
                  </button> -->
                 <!-- <LoadingButtonContent
                  :buyEnabled="payEnabled"
                  :clickAction="pay"
                  :buttonText="$t('home.pay')"
                ></LoadingButtonContent>
                <LoadingButtonContent
                  :buyEnabled="maxPayEnabled"
                  :clickAction="maxPay"
                  :buttonText="$t('home.pay1')"
                ></LoadingButtonContent> -->

                </p>
               
          
              </div>
            </div>
          </div>
          <div class="home-subtext">
            <p style="text-align: center">
             {{$t('home.ipfs')}}
              <!-- (
                <a
                href="/provenance.html"
                target="_blank"
                >Record and Proof</a
              >). -->

            </p>
          </div>
          <div class="progress" style="margin-top: 40px; margin-left: 50px">
            <div
              class="progress-bar"
              role="progressbar"
              v-for="(nftValue, index) in nftValArray"
              :key="index"
              :class="'inactive-progress'"
              v-bind:style="[
                { borderRight: '3px solid grey' },
                styles(nftValue.width),
                gradientStyles(index),
              ]"
              aria-valuemin="0"
              aria-valuemax="100"
            >
              {{ nftValue.usd }} B N B 
              <span>{{ nftValue.nftVal }} NFTs</span>
            </div>
          </div>
          <!-- Portfolio Wrap -->
          <div class="portfolio-wrap" style="text-align: center">
            <img
              src="../../public/images/mb1.jpg"
              style="width: 250px"
            />
            <img
              src="../../public/images/mb2.jpg"
              style="width: 250px"
            />
            <img
              src="../../public/images/mb3.jpg"
              style="width: 250px"
            />
            <img
              src="../../public/images/mb4.jpg"
              style="width: 250px"
            />
          </div>

         

          <h2 >
               {{$t('home.xt')}}
          </h2>
          <p>
               {{$t('home.xtt1')}}
          </p>

          <p>
            {{$t('home.xn2')}}
            <router-link to="manifesto">{{$t('home.xn3a')}}</router-link>.
          </p>

          <div class="row" style="margin-top: 80px; margin-bottom: 50px">
            <div class="col-lg-4 home-icon">
              <img src="../../public/images/icon-1.png" />

              <h6>
                  {{$t('home.mj1')}}
              </h6>
            </div>
            <div class="col-lg-4 home-icon">
              <img src="../../public/images/icon-2.png" />
              <h6>     {{$t('home.mj2')}}</h6>
            </div>
            <div class="col-lg-4 home-icon">
              <img src="../../public/images/icon-3.png" />

              <h6> {{$t('home.mj3')}}</h6>
            </div>
            <div class="col-lg-4 home-icon">
              <img src="../../public/images/icon-4.png" />

              <h6>
                {{$t('home.mj4')}}
              </h6>
            </div>
            <div class="col-lg-4 home-icon">
              <img src="../../public/images/icon-5.png" />
              <h6>
               {{$t('home.mj5')}}
              </h6>
            </div>
            <!-- /.col-lg-4 -->
            <div class="col-lg-4 home-icon">
              <img src="../../public/images/icon-6.png" />

              <h6> {{$t('home.mj6')}}</h6>
            </div>
            <!-- /.col-lg-4 -->
            <!-- /.col-lg-4 -->
          </div>
             <h2>{{$t('home.xt2')}}</h2>
          <p>
           {{$t('home.xt2n1')}}
          </p>
          <p>
            {{$t('home.xt2n2')}}
         
             <router-link to="/faq" >  {{$t('home.xt2n3')}} </router-link> 
             {{$t('home.xn2n4')}}
          </p>
          <p>
              {{$t('home.xn2n5')}}
             <router-link to="/faq">  {{$t('home.xn2n6')}}</router-link>  {{$t('home.xn2n7')}}
          </p>

          <div class="row">
            <div class="col-md-6">
              <img src="../../public/images/timeline-graphic.png" />
            </div>
            <div class="col-md-6">
              <img src="../../public/images/price-table.png" />
            </div>
          </div>

          <h2> {{$t('home.xn2n8')}}</h2>
          <p>
              {{$t('home.xn2n9')}}
          </p>

          <h2>  {{$t('home.xn2n10')}}</h2>
          <p>
              {{$t('home.xn2n11')}}
          </p>
          <p>
             {{$t('home.xn2n12')}}
          </p>
          <p>
             {{$t('home.xn2n112')}}
          </p>
          <h2>  {{$t('home.hct')}}</h2>
          <p>
              {{$t('home.hcn')}}
          </p>
        
          <!-- zb start -->
          <h2>
               {{$t('home.syt')}}
          </h2>
          <p>
              {{$t('home.sytn')}} 
          </p>
          <ul>
          <li>
             {{$t('home.sytn1')}}
          </li>
          
              <li>
                {{$t('home.sytn2')}}
              </li>
          <li>
              {{$t('home.sytn3')}}
          </li>
          <li>
             {{$t('home.sytn4')}}
          </li>
          </ul>
          <p>
           {{$t('home.sytn5')}}
          </p>

          <h2 >
              {{$t('home.ktt')}}
          </h2>
           <p>
             {{$t('home.kttn1')}}
          </p>
           <p>
           {{$t('home.kttn2')}}
          </p>
          <div class="portfolio-wrap" style="text-align: center">
          
            <img
              src="../../public/images/bz.jpeg"
              style="width: 350px;height:467px"
            />
              <img
              src="../../public/images/yf.jpeg"
              style="width: 350px;height:467px"
            />
            <img
              src="../../public/images/sjk.jpeg"
              style="width: 350px;height:467px"
            />
           
          </div>

      <!--zb  end-->

          
          <h2>  {{$t('home.gxt')}}</h2>
          <p>
              {{$t('home.gxn')}}
          </p>

           <h2>{{$t('home.sth')}}</h2>
        
            <div class="portfolio-wrap" style="text-align: center">
          
            
              <img
              src="../../public/images/bnbsc.png"
              style="width: 50%;height:50%"
            />
          <img
              src="../../public/images/bnnft.png"
              style="width: 50%;height:50%"
            />
           
          </div>

          

          <h2>Verified Smart Contracts</h2>
          <p class="ethereum-address-block">
            <b>pandas Contract: </b
            ><a
              href="https://bscscan.com/address/0x5f92f6E2Ef626679C1fA5539af3A36DaFfCac59b"
              >0x5f92f6E2Ef626679C1fA5539af3A36DaFfCac59b</a
            >
          </p>
          <p class="ethereum-address-block">
            <b>NameChangeToken Contract: </b>
            <a
              href="https://bscscan.com/address/0x762d41B44b43a54927A45259F903d369Aa48249f"
              >0x762d41B44b43a54927A45259F903d369Aa48249f</a
            >
          </p>

        
           <h2>{{$t('home.st')}}</h2>
          <p class="ethereum-address-block">
           {{$t('home.stn')}}
            

          </p>
          <!-- Portfolio Wrap Ends -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getNFTPrice,
  getPandasContract,
  ethEnabled,
  maxUserCanBuy,
} from '../helpers/contract.js';
import LoadingButtonContent from '@/components/LoadingButtonContent';

import Vue from 'vue';
import vmodal from 'vue-js-modal';

Vue.use(vmodal);

export default {
  name: 'Home',
  components: { LoadingButtonContent },
  data() {
    return {
      currentAddress: null,
      remainingAtCurrentPrice: 0,
      saleStart: '31 May 2021 16:00:00 GMT',
      saleStarted: true,
      progressBarValues: [],
      buyEnabled: true,
      payEnabled: true,
      maxPayEnabled: true,
      qtyToBuy: 1,
      validationResult: '',
      totalSupply: 0,
      checkedTerms: false,
      checkedCountry: false,
      nftValArray: [
        {
          nftVal: 3000,
          usd: 0.25,
          width: 16,
        },
        {
          nftVal: 4000,
          usd: 0.35,
          width: 20,
        },
        {
          nftVal: 4000,
          usd: 0.5,
          width: 20,
        },
        {
          nftVal: 4000,
          usd: 0.6,
          width: 20,
        },
        {
          nftVal: 800,
          usd: 0.8,
          width: 12,
        },
        {
          nftVal: 174,
          usd: 1.0,
          width: 8,
        },
        {
          nftVal: 3,
          usd: 100,
          width: 4,
        },
      ],
    };
  },
  async mounted() {
    this.saleStarted = Number(new Date().getTime() / 1000) >= 1621263600;
    await this.updatePriceAndSupply();
    this.timer = setInterval(this.updatePriceAndSupply, 60000);
  },
  watch: {
    totalSupply(newVal) {
      let tempTotalSupply = newVal;
      let arr = [];
      for (let i of this.nftValArray) {
        if (tempTotalSupply > i.nftVal) {
          arr.push(100);
          tempTotalSupply -= i.nftVal;
        } else {
          arr.push((tempTotalSupply / i.nftVal) * 100);
          tempTotalSupply = 0;
        }
      }
      this.progressBarValues = arr;
    },
  },
  methods: {
     pay: async function(event) {
     
       var number = this.$refs.getValue.value;
      this.payEnabled = false;
      const pandasContract = await getPandasContract();
       //const prices = await getNFTPrice();
       const prices = 250000000000000000;
        if (this.totalSupply >= 15974) {
            prices = 100000000000000000000; // 15974 - 15976 100 BNB
        } else if (this.totalSupply >= 15800) {
             prices = 1000000000000000000; // 15800 - 15973 1.0 BNB
        } else if (this.totalSupply >= 15000) {
             prices = 800000000000000000; // 15000  - 15799 0.8 BNB
        } else if (this.totalSupply >= 11000) {
             prices = 600000000000000000; // 11000 - 14999 0.6 BNB
        } else if (this.totalSupply >= 7000) {
             prices = 500000000000000000; // 7000 - 10999 0.5 BNB
        } else if (this.totalSupply >= 3000) {
             prices = 350000000000000000; // 3000 - 6999 0.3 BNB
        } 

      
       const defaultAccount = await ethEnabled();
        
       pandasContract.methods.mintNFT(number).send({ from: defaultAccount },{value: prices*number})
        .on('transactionHash', (hash) => {
          this.$store.commit('addPendingTx', {
            txHash: hash,
            description: 'Buy',
          });
        })
        // eslint-disable-next-line no-unused-vars
        .on('receipt', (receipt) => {
          this.payEnabled = true;
          // this.updateNCTState();
        })
        .on('error', (err) => {
          console.log(err);
          this.payEnabled = true;
        }); // If a out of gas error, the second parameter is the receipt.
      this.$modal.hide('pay');
      event.preventDefault();

     }, 
     maxPay: async function(event) {
     
      var number = await maxUserCanBuy();
      
      this.maxPayEnabled = false;
      const pandasContract = await getPandasContract();
      // const prices = await getNFTPrice();
       const prices = 250000000000000000;
        if (this.totalSupply >= 15974) {
            prices = 100000000000000000000; // 15974 - 15976 100 BNB
        } else if (this.totalSupply >= 15800) {
             prices = 1000000000000000000; // 15800 - 15973 1.0 BNB
        } else if (this.totalSupply >= 15000) {
             prices = 800000000000000000; // 15000  - 15799 0.8 BNB
        } else if (this.totalSupply >= 11000) {
             prices = 600000000000000000; // 11000 - 14999 0.6 BNB
        } else if (this.totalSupply >= 7000) {
             prices = 500000000000000000; // 7000 - 10999 0.5 BNB
        } else if (this.totalSupply >= 3000) {
             prices = 350000000000000000; // 3000 - 6999 0.3 BNB
        } 
      
      
       const defaultAccount = await ethEnabled();
        
       pandasContract.methods.mintNFT(number).send({ from: defaultAccount },{value: prices*number})
        .on('transactionHash', (hash) => {
          this.$store.commit('addPendingTx', {
            txHash: hash,
            description: 'Max Buy',
          });
        })
        // eslint-disable-next-line no-unused-vars
        .on('receipt', (receipt) => {
          this.maxPayEnabled = true;
          // this.updateNCTState();
        })
        .on('error', (err) => {
          console.log(err);
          this.maxPayEnabled = true;
        }); // If a out of gas error, the second parameter is the receipt.
      this.$modal.hide('maxPay');
      event.preventDefault();

     },
    async updatePriceAndSupply() {
      const pandasContract = await getPandasContract();
      this.totalSupply = await pandasContract.methods.totalSupply().call();
       console.info(this.totalSupply);
      let remainingSupply = this.totalSupply;
      for (let obj of this.nftValArray) {
       
        if (remainingSupply >= obj.nftVal) {
          remainingSupply -= obj.nftVal;
        } else {
          this.remainingAtCurrentPrice = obj.nftVal - remainingSupply;
          break;
        }
      }
    },
    gradientStyles: function (index) {
      let val = this.progressBarValues[index];

      return {
        background:
          'linear-gradient(to right, orange 0%,orange ' +
          val +
          '%,#f6f6f6 ' +
          val +
          '%,#f6f6f6 100%',
      };
    },
    styles: function (id) {
      return {
        width: id + '%',
      };
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
    

};


</script>

<style>
/* [aria-valuenow="20"] {
  color: red !important;
} */
.active-progress {
  background: orange;
}
.inactive-progress {
  background: #dddddd;
  color: gray;
}
</style>
